document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-product-gallery]').forEach(gallery=>{
    const hint=gallery.parentElement.querySelector('.product-swipe-hint');
    const update=()=>{
      if(!hint) return;
      const atEnd=gallery.scrollLeft + gallery.clientWidth >= gallery.scrollWidth - 8;
      hint.textContent=atEnd ? '← SWIPE BACK' : 'SWIPE TO VIEW MORE →';
    };
    gallery.addEventListener('scroll',()=>requestAnimationFrame(update),{passive:true});
    update();
  });
});